<ng-container *ngIf="show">
    <p-progressBar
        [mode]="mode"
        [value]="progress">
    </p-progressBar>
</ng-container>
